// Components==============
import updateUser from 'actions/authentication/updateUser';
import { MenuContext } from 'components/Layout/Menu/Menu';
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../DatePicker/DatePicker';
import './DeleteModal.module.scss';
// =========================

export default function DeleteModal() {
    const { setActiveLogForDeleteModal, activeLogForDeleteModal } = useContext(
        MenuContext
    );

    const dispatch = useDispatch();

    const logbook = useSelector(
        (state: ReduxStore) => state?.authentication?.user
    )?.logbook;

    function handleDeleteWeek() {
        const newEntry = logbook?.filter(
            (l) => l.key !== activeLogForDeleteModal?.key
        );

        dispatch(updateUser({ logbook: newEntry }));
        setActiveLogForDeleteModal(undefined);
    }

    if (!activeLogForDeleteModal) return <></>;

    return (
        // @ts-ignore because setState is passed via context. (is necessary because Modal is rendered outside calendar component)
        <Modal>
            <div styleName="wrapper">
                <h3>
                    Weet je zeker dat je het logboek van deze week wil
                    verwijderen?
                </h3>
                <p>
                    Je staat op het punt om het logboek van de week:{' '}
                    {formatDate(activeLogForDeleteModal)} te verwijderen. Als je
                    dit doet kun je deze niet meer terug halen.
                </p>
                <div styleName="button-wrapper">
                    <Button
                        lightgrey
                        onClick={() => setActiveLogForDeleteModal(undefined)}
                    >
                        Annuleren
                    </Button>
                    <Button lightgreyRed onClick={handleDeleteWeek}>
                        Verwijderen
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
